import React, { PureComponent } from "react";
import { withRouter } from "react-router-dom";

import { connect } from "react-redux";
import { listCategoryProducts } from "../../redux/product/product.actions";

import ProductList from "../../components/Categories/Product";

import PageTitle from "../../components/Page-header";
import ProductWrapper from "../../components/Categories/Product-Wrapper";

class CategoryPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      categoryId: this.props.match.params.id,
    };
  }

  // async componentDidMount() {
  //   this.props.listCategoryProducts(this.state.categoryId);
  // }

  // async componentDidUpdate(prevProps) {
  //   if (this.props.match.params.id !== prevProps.match.params.id) {
  //     this.props.listCategoryProducts(this.props.match.params.id);
  //   }
  // }

  render() {
    let passIngCats = this.props.match.params.id === "clothes" ? clothes : tech;

    return (
      <>
        <PageTitle title={this.props.match.params.id} />
        <ProductWrapper>
          {this.props.catProducts && (
            <ProductList items={passIngCats} />
          )}
        </ProductWrapper>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  catProducts: state.productList.catProd,
});

const mapDispatchToProps = (dispatch) => ({
  listCategoryProducts: (data) => dispatch(listCategoryProducts(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CategoryPage));

const clothes = [
  {
    id: "huarache-x-stussy-le",
    name: "Nike Air Huarache Le",
    category: "clothes",
    brand: "Nike x Stussy",
    inStock: true,
    gallery: [
      "https://cdn.shopify.com/s/files/1/0087/6193/3920/products/DD1381200_DEOA_2_720x.jpg?v=1612816087",
      "https://cdn.shopify.com/s/files/1/0087/6193/3920/products/DD1381200_DEOA_1_720x.jpg?v=1612816087",
      "https://cdn.shopify.com/s/files/1/0087/6193/3920/products/DD1381200_DEOA_3_720x.jpg?v=1612816087",
      "https://cdn.shopify.com/s/files/1/0087/6193/3920/products/DD1381200_DEOA_5_720x.jpg?v=1612816087",
      "https://cdn.shopify.com/s/files/1/0087/6193/3920/products/DD1381200_DEOA_4_720x.jpg?v=1612816087",
    ],
    attributes: [
      {
        id: "Size",
        items: [
          { value: "40", id: "40" },
          { value: "41", id: "41" },
          { value: "42", id: "42" },
          { value: "43", id: "43" },
        ],
      },
    ],
    prices: [
      { amount: 144.69 },
      { amount: 104 },
      { amount: 186.65 },
      { amount: 15625.24 },
      { amount: 10941.76 },
    ],
  },
  {
    id: "jacket-canada-goosee",
    name: "Jacket",
    category: "clothes",
    brand: "Canada Goose",
    inStock: true,
    gallery: [
      "https://images.canadagoose.com/image/upload/w_480,c_scale,f_auto,q_auto:best/v1576016105/product-image/2409L_61.jpg",
      "https://images.canadagoose.com/image/upload/w_480,c_scale,f_auto,q_auto:best/v1576016107/product-image/2409L_61_a.jpg",
      "https://images.canadagoose.com/image/upload/w_480,c_scale,f_auto,q_auto:best/v1576016108/product-image/2409L_61_b.jpg",
      "https://images.canadagoose.com/image/upload/w_480,c_scale,f_auto,q_auto:best/v1576016109/product-image/2409L_61_c.jpg",
      "https://images.canadagoose.com/image/upload/w_480,c_scale,f_auto,q_auto:best/v1576016110/product-image/2409L_61_d.jpg",
      "https://images.canadagoose.com/image/upload/w_480,c_scale,f_auto,q_auto:best/v1576016111/product-image/2409L_61_e.jpg",
    ],
    attributes: [
      {
        id: "Size",
        items: [
          { value: "S", id: "Small" },
          { value: "M", id: "Medium" },
          { value: "L", id: "Large" },
          { value: "XL", id: "Extra Large" },
        ],
      },
    ],
    prices: [
      { amount: 518.47 },
      { amount: 372.67 },
      { amount: 668.83 },
      { amount: 55990.46 },
      { amount: 39207.96 },
    ],
  },
];

const tech = [
  {
    id: "ps-5",
    name: "PlayStation 5",
    category: "tech",
    brand: "Sony",
    inStock: false,
    gallery: [
      "https://images-na.ssl-images-amazon.com/images/I/510VSJ9mWDL._SL1262_.jpg",
      "https://images-na.ssl-images-amazon.com/images/I/610%2B69ZsKCL._SL1500_.jpg",
      "https://images-na.ssl-images-amazon.com/images/I/51iPoFwQT3L._SL1230_.jpg",
      "https://images-na.ssl-images-amazon.com/images/I/61qbqFcvoNL._SL1500_.jpg",
      "https://images-na.ssl-images-amazon.com/images/I/51HCjA3rqYL._SL1230_.jpg",
    ],
    attributes: [
      {
        id: "Color",
        items: [
          { value: "#44FF03", id: "Green" },
          { value: "#03FFF7", id: "Cyan" },
          { value: "#030BFF", id: "Blue" },
          { value: "#000000", id: "Black" },
          { value: "#FFFFFF", id: "White" },
        ],
      },
      {
        id: "Capacity",
        items: [
          { value: "512G", id: "512G" },
          { value: "1T", id: "1T" },
        ],
      },
    ],
    prices: [
      { amount: 844.02 },
      { amount: 606.67 },
      { amount: 1088.79 },
      { amount: 91147.25 },
      { amount: 63826.91 },
    ],
  },
  {
    id: "xbox-series-s",
    name: "Xbox Series S 512GB",
    category: "tech",
    brand: "Microsoft",
    inStock: false,
    gallery: [
      "https://images-na.ssl-images-amazon.com/images/I/71vPCX0bS-L._SL1500_.jpg",
      "https://images-na.ssl-images-amazon.com/images/I/71q7JTbRTpL._SL1500_.jpg",
      "https://images-na.ssl-images-amazon.com/images/I/71iQ4HGHtsL._SL1500_.jpg",
      "https://images-na.ssl-images-amazon.com/images/I/61IYrCrBzxL._SL1500_.jpg",
      "https://images-na.ssl-images-amazon.com/images/I/61RnXmpAmIL._SL1500_.jpg",
    ],
    attributes: [
      {
        id: "Color",
        items: [
          { value: "#44FF03", id: "Green" },
          { value: "#03FFF7", id: "Cyan" },
          { value: "#030BFF", id: "Blue" },
          { value: "#000000", id: "Black" },
          { value: "#FFFFFF", id: "White" },
        ],
      },
      {
        id: "Capacity",
        items: [
          { value: "512G", id: "512G" },
          { value: "1T", id: "1T" },
        ],
      },
    ],
    prices: [
      { amount: 333.99 },
      { amount: 240.07 },
      { amount: 430.85 },
      { amount: 36068.27 },
      { amount: 25257.22 },
    ],
  },
  {
    id: "apple-imac-2021",
    name: "iMac 2021",
    category: "tech",
    brand: "Apple",
    inStock: true,
    gallery: [
      "https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/imac-24-blue-selection-hero-202104?wid=904&hei=840&fmt=jpeg&qlt=80&.v=1617492405000",
    ],
    attributes: [
      {
        id: "Capacity",
        items: [
          { value: "256GB", id: "256GB" },
          { value: "512GB", id: "512GB" },
        ],
      },
      {
        id: "With USB 3 ports",
        items: [
          { value: "Yes", id: "Yes" },
          { value: "No", id: "No" },
        ],
      },
      {
        id: "Touch ID in keyboard",
        items: [
          { value: "Yes", id: "Yes" },
          { value: "No", id: "No" },
        ],
      },
    ],
    prices: [
      { amount: 1688.03 },
      { amount: 1213.34 },
      { amount: 2177.57 },
      { amount: 182294.51 },
      { amount: 127653.82 },
    ],
  },
  {
    id: "apple-iphone-12-pro",
    name: "iPhone 12 Pro",
    category: "tech",
    brand: "Apple",
    inStock: true,
    gallery: [
      "https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-12-pro-family-hero?wid=940&amp;hei=1112&amp;fmt=jpeg&amp;qlt=80&amp;.v=1604021663000",
    ],
    attributes: [
      {
        id: "Capacity",
        items: [
          { value: "512G", id: "512G" },
          { value: "1T", id: "1T" },
        ],
      },
      {
        id: "Color",
        items: [
          { value: "#44FF03", id: "Green" },
          { value: "#03FFF7", id: "Cyan" },
          { value: "#030BFF", id: "Blue" },
          { value: "#000000", id: "Black" },
          { value: "#FFFFFF", id: "White" },
        ],
      },
    ],
    prices: [
      { amount: 1000.76 },
      { amount: 719.34 },
      { amount: 1290.99 },
      { amount: 108074.6 },
      { amount: 75680.48 },
    ],
  },
  {
    id: "apple-airpods-pro",
    name: "AirPods Pro",
    category: "tech",
    brand: "Apple",
    inStock: false,
    gallery: [
      "https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/MWP22?wid=572&hei=572&fmt=jpeg&qlt=95&.v=1591634795000",
    ],
    attributes: [],
    prices: [
      { amount: 300.23 },
      { amount: 215.8 },
      { amount: 387.3 },
      { amount: 32422.38 },
      { amount: 22704.14 },
    ],
  },
  {
    id: "apple-airtag",
    name: "AirTag",
    category: "tech",
    brand: "Apple",
    inStock: true,
    gallery: [
      "https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/airtag-double-select-202104?wid=445&hei=370&fmt=jpeg&qlt=95&.v=1617761672000",
    ],
    attributes: [],
    prices: [
      { amount: 120.57 },
      { amount: 86.67 },
      { amount: 155.54 },
      { amount: 13021.04 },
      { amount: 9118.13 },
    ],
  },
];
